import { useTranslation } from 'react-i18next';

import { Badge, type BadgeTone } from '@/components/atoms/Badge';
import type { FishGroupStatus } from '@/domain/fishGroups';

// Only a live group and a discarded one stand out; the other states are history.
const STATUS_TONE: Partial<Record<FishGroupStatus, BadgeTone>> = {
    active: 'success',
    discarded: 'danger',
};

interface FishGroupStatusBadgeProps {
    status: FishGroupStatus;
    className?: string;
}

export default function FishGroupStatusBadge(props: FishGroupStatusBadgeProps) {
    const { status, className } = props;
    const { t } = useTranslation('fishGroups');

    return (
        <Badge tone={STATUS_TONE[status] ?? 'neutral'} className={className}>
            {t(`cageTimeline.status.${status}`, { defaultValue: status })}
        </Badge>
    );
}
